enum TaskType {
    EXPERT = 'expert',
    TEST = 'test',
    TEST_PRO = 'test_pro',
    ASSESSMENT = 'assessment',
    BATTERY = 'battery',
}

export default TaskType;